import ResponsiveDialogHeader from './ResponsiveDialogHeader';
export default ResponsiveDialogHeader;